// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"gamepad"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 4H21L22 20H17L16 17H8L7 20H2L3 4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 4H21L22 20H17L16 17H8L7 20H2L3 4Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 10.5L8 10.5M8 10.5L6 10.5M8 10.5V8.5M8 10.5L8 12.5M17 8.5H17.0039V8.50391H17V8.5ZM17 12.4961H17.0039V12.5H17V12.4961Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-gamepad')
export default class GamepadIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'gamepad',
    }
  }
}
